import React, { useCallback, useState, useMemo } from 'react';
import { OptionsType, ValueType, StylesConfig } from 'react-select';
import useHttp from 'app/utils/hooks/use-http';

import MAddressInputView from './MAddressInput.view';


interface Props {
  className?: string;
  placeholder?: string;
  name?: string;
  value?: string | null;
  customStylesSelect?: StylesConfig<{ label: string; value: string }, false>;
  disabled?: boolean;
  onChange?: (value: ValueType<{ label: string; value: string }, false>) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  onMenuClose?: () => void;
}

const MAddressInput: React.FC<Props> = (props: Props) => {
  const http = useHttp();

  const [optionsState, setOptionsState] = useState<{ label: string; value: string }[]>([]);

  const loadOptions$ = useCallback(
    (inputValue: string, callback: (options: OptionsType<{ label: string; value: string }>) => void) => {
      const options$ = http.google.autoComplete(inputValue);

      return options$
        .then((addresses: string[]) => {
          const items = addresses.map((address: string) => {
            return { label: address.split('|')[0], value: address };
          });

          setOptionsState(() => items);
          callback(items);
        })
        .catch(console.error);
    },
    [http],
  );

  const value = useMemo(() => {
    if (props.value) {
      return optionsState.find((option: { label: string; value: string }) => option.value === props.value) || { label: props.value, value: props.value };
    }

    return null;
  }, [props.value, optionsState]);

  return (
    <MAddressInputView
      className={props.className}
      placeholder={props.placeholder}
      name={props.name}
      value={value}
      customStylesSelect={props.customStylesSelect}
      disabled={props.disabled}
      onChange={props.onChange}
      onBlur={props.onBlur}
      onMenuClose={props.onMenuClose}
      loadOptions={loadOptions$}
    ></MAddressInputView>
  );
};

MAddressInput.displayName = 'MAddressInput';
MAddressInput.defaultProps = {};

export default MAddressInput;
